export default __webpack_public_path__ + "static/media/word-cloud.73e93759.png";